import {
  IonAvatar,
  IonButton,
  IonCard,
  IonImg,
  IonSkeletonText,
  useIonModal
} from "@ionic/react";
import { useUsersStore } from "../stores/users.store";
import ProfileHeader from "./ProfileHeader";
import { useQuestsStore } from "../stores/quests.store";
import { SetupBot } from "../pages/SetupBot";
import { setFirebaseDocument } from "../lib/firebase";

const QuoQuestProfileCard: React.FC = () => {
  const profile = useUsersStore(state => state.user);
  const [userBot, questId] = useQuestsStore(state => [state.bot, state.id]);

  const [presentSetupBot, dismissSetupBot] = useIonModal(SetupBot, {
    questBot: userBot,
    mode: "quest",
    onDismiss: async (bot: any) => {
      dismissSetupBot();
      if (bot) {
        await setFirebaseDocument("quests", { bot }, questId);
      }
    }
  });

  if (!userBot) return null;

  if (!profile)
    return (
      <IonCard className="bg-primary-50 w-full m-0 h-[170px]">
        <IonSkeletonText animated className="w-full h-full" />
      </IonCard>
    );
  return (
    <IonCard className="bg-primary-50 w-full m-0">
      <div>
        <ProfileHeader profile={profile} />
        <div className="bg-primary-80 p-2 flex items-center">
          <IonAvatar className="w-10 h-10 border-white border m-2 bg-slate-300">
            {userBot?.img && <IonImg src={userBot?.img} alt="bot avatar" />}
          </IonAvatar>
          <div className="text-white text-sm">{userBot?.name}</div>
          <IonButton
            color="primary"
            className="rounded-lg ml-auto"
            onClick={() => presentSetupBot()}
          >
            Edit Bot
          </IonButton>
        </div>
      </div>
    </IonCard>
  );
};

export default QuoQuestProfileCard;
